import { render } from "./OperatorsList.vue?vue&type=template&id=3a954e86"
import script from "./OperatorsList.vue?vue&type=script&lang=js"
export * from "./OperatorsList.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__